<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Input v-model="params.name" placeholder="类别名称" clearable style="width: 200px"/>
            </div>
            <div class="hs-screen-row">
                <Select v-model="params.disableRecoveryCategory" placeholder="状态" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="0">已启用</Option>
                    <Option value="1">已禁用</Option>
                </Select>
            </div>
            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="findList">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>类别列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                            <Button @click="showBannerOpe(2, '', 1)">新增类别</Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table row-key="categoryId" :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

                <template slot-scope="{ row, index }" slot="isDisable">
                    <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
                    <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
                </template>

                <template slot-scope="{row, index}" slot="icon">
                    <div class="j-banner-image">
                        <img :src="row.icon">
                    </div>
                </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="success" size="small" style="margin-right: 5px" @click="showBannerOpe(1, row)">查看
                    </Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="showBannerOpe(3, row, row.level)">编辑
                    </Button>

                    <Dropdown transfer trigger="click">
                        <Button size="small">
                            <Icon type="ios-more" size="22"/>
                        </Button>
                        <DropdownMenu slot="list">
                            <DropdownItem v-if="row.disableRecoveryCategory === 0" @click.native="disableRecoveryCategoryUser(row)">禁用
                            </DropdownItem>
                            <DropdownItem v-if="row.disableRecoveryCategory === 1" @click.native="disableRecoveryCategoryUser(row)">启用
                            </DropdownItem>
                            <DropdownItem @click.native="isDelUser(row)">删除</DropdownItem>
                            <DropdownItem v-if="row.level < 2" @click.native="showBannerOpe(2, row, row.level + 1)">添加下级</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>

        <!--显示模态框-->
        <banner-ope ref="bannerOpe" @changeDate="findList"></banner-ope>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import bannerOpe from './components/category-ope';

    export default {
        data() {
            return {
                admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
                total: 0,
                dateInit: '',
                isTableLoading: false,
                // 参数
                params: {
                    page: 1,
                    rows: 10,
                    name: '',
                    disableRecoveryCategory: '',
                    startTime:'',
                    endTime: '',
                },
                // 表格列
                columns: [
                    {
                        title: 'ID',
                        minWidth: 180,
                        key: 'categoryId',
                        tree: true
                    },
                    {
                        title: '图片',
                        minWidth: 120,
                        slot: 'icon'
                    },
                    {
                        title: '名称',
                        minWidth: 120,
                        key: 'name'
                    },
                    {
                        title: '普通单价',
                        minWidth: 120,
                        key: 'priceMin'
                    },
                    {
                        title: '会员单价',
                        minWidth: 120,
                        key: 'priceMax'
                    },
                    {
                        title: '排序',
                        minWidth: 120,
                        key: 'sort'
                    },
                    {
                        title: '状态',
                        slot: 'isDisable',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '类别管理', url: '', icon: '', size: 0},
                    {name: '类别列表', url: '', icon: '', size: 0}
                ],
              tenantList: []
            }
        },
        created() {
            this.findList();
        },
        methods: {
            // 类别-列表查询
            findList() {
                this.isTableLoading = true;
                this.axios.post('/recoveryCategory/findList', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查询类别列表接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 是否删除类别
            isDelUser(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否删除当前类别？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.deleteRecoveryCategory(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 是否禁用类别
            disableRecoveryCategoryUser(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否${row.disableRecoveryCategory ? '开启' : '禁用'}当前类别？`,
                    onOk: () => {
                        this.disableRecoveryCategory(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 删除类别
            deleteRecoveryCategory(row) {
                this.$Spin.show();
                this.axios.post('/recoveryCategory/deleteRecoveryCategory', {
                    categoryId: row.categoryId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '删除类别失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '删除类别接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 禁用或开启类别
            disableRecoveryCategory(row) {
                this.$Spin.show();
                this.axios.post('/recoveryCategory/disableRecoveryCategory', {
                    categoryId: row.categoryId,
                    isDisable: row.isDisable ? 0 : 1
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '禁用类别接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 显示操作模态框
            showBannerOpe(type, row, level) {
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                this.$refs.bannerOpe.show(type, row, level);
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            // 重置筛选条件
            resetScreen() {
                this.params.jumpType = '';
                this.params.disableRecoveryCategory = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.dateInit = '';
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findList();
            },
        },
        components: {
            hsBreadcrumb,
            bannerOpe
        }
    }
</script>

<style scoped>
    .j-banner-image{
        width: 100px;
        height: 50px;
        padding: 5px;
    }
    .j-banner-image img{
        width: auto;
        height: 100%;
    }
</style>